<template>
  <span class="v-tooltip">
    <slot />
  </span>
</template>

<script>
  export default {
    data() {
      return {
      };
    },
    mounted: function () {
      const self = this;
      window.addEventListener('scroll', () => {
        self.$children[0].callDeactivate();
      })
    }
  }
</script>
